export default "__VITE_ASSET__01474551__"